
document.addEventListener('DOMContentLoaded', ()=> {
    var mySwiper = new Swiper('.swiper-container.subcategory-list--container', {  
        spaceBetween: 5,  
        slidesPerView: 3.2,  
        grabCursor: true,  
        freeMode: true,  
        slidesPerGroup: 1,
        loop: false,
        breakpoints: {  
            640: {          // When the viewport is 640px or smaller  
                slidesPerView: 3.2, 
                spaceBetween: 5,   
            },  
            768: {          // When the viewport is 768px or smaller  
                slidesPerView: 5.5,
            },  
            1024: { // When viewport is 768px or smaller  
                slidesPerView: 7, // Set this to a number if you want specific counts  
                spaceBetween: 12 // Add space between slides  
            },  
            1400: { // When the viewport is 1024px or larger
                slidesPerView: 8.5,   
                spaceBetween: 10 // Ensure space between is set  
            }  
        }  
        
    }); 
})


